import { Agent } from '../types';

export class AgentService {
  constructor(private baseUrl: string, private identityApi: any) {}

  private async getHeaders(): Promise<Record<string, string>> {
    const credentials = await this.identityApi.getCredentials();
    return {
      Authorization: `Bearer ${credentials.token}`,
      'Content-Type': 'application/json',
    };
  }

  async fetchAgents(namespace?: string): Promise<Agent[]> {
    try {
      const headers = await this.getHeaders();
      const url = namespace
        ? `${this.baseUrl}/api/custom-api/agents?namespace=${namespace}`
        : `${this.baseUrl}/api/custom-api/agents`;
      const response = await fetch(url, { headers });
      if (!response.ok) throw new Error(response.statusText);
      const data = await response.json();
      return (data as any[]).map(agent => ({
        name: agent.name,
        apiName: agent.api_name,
        icon: agent.icon,
        color: agent.color,
        heading: agent.heading,
        protocol: agent.protocol,
        prompts: agent.prompts || {},
      }));
    } catch {
      return [];
    }
  }

  async createSession(apiName: string): Promise<string | null> {
    try {
      const headers = await this.getHeaders();
      const profile = await this.identityApi.getProfileInfo();
      const response = await fetch(
        `${this.baseUrl}/api/custom-api/agents/${apiName}/session`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify({
            userId: profile.email,
            userEmail: profile.email,
            userName: profile.displayName,
          }),
        },
      );
      if (!response.ok) return null;
      const data = await response.json();
      return (data as any).sessionId;
    } catch {
      return null;
    }
  }

  async sendMessage(
    message: string,
    apiName: string,
    sessionId?: string,
    signal?: AbortSignal,
    extraContext?: Record<string, string>,
  ): Promise<Response> {
    const headers = await this.getHeaders();
    const profile = await this.identityApi.getProfileInfo();
    return fetch(`${this.baseUrl}/api/custom-api/agents/${apiName}/chat`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        message,
        sessionId,
        userId: profile.email,
        userEmail: profile.email,
        userName: profile.displayName,
        ...(extraContext || {}),
      }),
      signal,
    });
  }
}
